// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bYhR","newExpiryDate":"styles_newExpiryDate___sjF4","footer":"styles_footer__3KlWu"};